import { Action, OverlayOptions } from "./reducer"

import { Dispatch } from "react"
import { ReactNode } from "react"

const openOverlay = (dispatch: Dispatch<Action>, content: ReactNode, options: OverlayOptions = {}) => {
    dispatch({ type: "OPEN_OVERLAY", payload: { content: content, ...options } })
    document.body.classList.add("noScroll")
    return
}

const closeOverlay = (dispatch: Dispatch<Action>) => {
    dispatch({ type: "CLOSE_OVERLAY" })
    document.body.classList.remove("noScroll")
    return
}

const updateHeader = (dispatch: Dispatch<Action>, header: ReactNode) => {
    return dispatch({ type: "UPDATE_HEADER", payload: { header: header } })
}

export { openOverlay, closeOverlay, updateHeader }
